<template>
    <img :src="require('@/assets/images/branding/logotipo-unifrutti.png')" />
</template>

<script>
export default {
    name: 'Logo',
};
</script>

<style></style>
